<template>
<div class="dashboard-container">
    <v-row justify="space-between" align="end" dense>
        <v-col cols="auto" class="d-flex align-center">
            <h1 class="dashboard-title">Dashboard de Ventas</h1>
        </v-col>
        <v-col class="d-flex justify-center align-center">
        <v-img
          max-height="120"
          max-width="120"
          :src="logo"
        ></v-img>
        </v-col>
        <v-col cols="auto" class="text-right">
          <div class="d-flex justify-space-between">
            <div>
              <div class="current-time">{{ currentTimeFormatted }}</div>
              <div class="current-date">{{ currentDateFormatted }}</div>
            </div>
            <div class="ml-2">
              <v-img
          max-height="50"
          max-width="60"
          :src="logoRunflow"
         
        ></v-img>
            </div>

          </div>
        </v-col>
    </v-row>
  
    <v-row v-if="loading">
        <v-col cols="6">
            <v-skeleton-loader
            height="400"
            type="card"
            ></v-skeleton-loader>
        </v-col>
        <v-col cols="6">
            <v-skeleton-loader
            height="400"
            type="card"
            ></v-skeleton-loader>
        </v-col>
    </v-row>

    <v-row v-else class="mb-0">
     
            <v-col class="pb-0" cols="6" v-show="this.parameters.dashboard_card_quoted">
                <v-card class="metric-card" height="150" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper blue-bg">
                                <v-icon color="white" size="30">mdi-currency-usd</v-icon>
                            </div>
                            <div class="metric-title">Cotizado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_quoted | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
      
            <v-col class="pb-0" cols="6" v-show="this.parameters.dashboard_card_confirmed">
                <v-card class="metric-card" height="150" elevation="1">
                    <v-card-text class="pa-4">
                        <div class="metric-header">
                            <div class="metric-icon-wrapper orange-bg">
                                <v-icon color="white" size="30">mdi-check-circle</v-icon>
                            </div>
                            <div class="metric-title">Confirmado</div>
                        </div>
                        <div class="metric-body">
                            <div class="metric-value">{{total_confirmed | moneda}}</div>
                            <div class="metric-label">TOTAL DEL PERÍODO</div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
   
    </v-row>
    <top-seller-list :dateRange='dateRange' :customers='customers' :sellers='sellers' :loading='loading'/>

</div>
</template>

<script>
import {fetchDayGraph} from '@/api/salesNotes'
import DayGraphComplete from '@/components/sales/DayGraphComplete'
import TopSellerList from '@/components/sales/TopSellerList.vue'
import logoRunflow from '@/assets/runflow_logo.png'
const moment = require('moment')
export default {
    name: 'SalesDashboard',
    components: {
        DayGraphComplete,
        TopSellerList
    },
    data(){
        return {
          logoRunflow:logoRunflow,
            optionSelected:{},
            dateRange:[moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('yyyy-MM-DD'), moment().format('YYYY-MM-DD')],
            menuDate:false,
            dataRange:[
                {
                text:  moment(new Date().toString()).format('MMMM-YYYY'),
                after: moment(new Date().toString()).format('YYYY')+'-'+moment(new Date().toString()).format('MM')+'-01',
                before:moment(new Date().toString()).format('YYYY-MM-DD'),
                format:'DD-MM-YYYY',
                monthly:''
                },
                {
                    text:'30 días',
                    after: moment(new Date().toString()).add(-1,'month').format('YYYY-MM-DD'),
                    before:moment(new Date().toString()).format('YYYY-MM-DD'),
                    format:'DD-MM-YYYY',
                    monthly:''
                },
                {
                    text:'12 Meses',
                    after:moment(new Date().toString()).add(-1,'year').format('YYYY-MM-DD'),
                    before:moment(new Date().toString()).format('YYYY-MM-DD'),
                    format:'MMM',
                    monthly:true
                }
            ],
            quoted:[],
            confirmed:[],
            confirmed_finished:[],
            invoices:[],
            payments:[],
            customers:[],
            sellers:[],
            total_quoted:0,
            total_confirmed:0,
            total_confirmed_finished:0,
            total_confirmed_finished_not_invoiced:0,
            total_invoiced:0,
            total_payments:0,
            total_purchase_subtotal:0,
            total_purchase_payments:0,
            loading:false,
            currentTime: new Date(),
            timeInterval: null,
        }
    },
    computed: {
      computedDateFormattedMomentjs () {
        return `${this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[0]?this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[0]:''} - ${this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[1]?this.dateRange.map(date => moment(date).format('DD-MMM-YYYY'))[1]:''}`
      },
      parameters(){
        return this.$store.getters.getCompany
      },
      currentTimeFormatted() {
        return this.currentTime.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
      },
      currentDateFormatted() {
        return this.currentTime.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      },
      topVendedores() {
        if (!this.sellers || this.sellers.length === 0) return [];
        const totalConfirmed = this.sellers.reduce((sum, seller) => sum + (seller.confirmed || 0), 0);
        return this.sellers
          .map(seller => ({
            ...seller,
            percentage: totalConfirmed > 0 ? ((seller.confirmed || 0) / totalConfirmed * 100).toFixed(1) : 0
          }))
          .sort((a, b) => (b.confirmed || 0) - (a.confirmed || 0))
          .slice(0, 5);
      },
    logo(){
        return this.$store.getters.getCompany.logo_url
      },
    },
    methods:{
        getSellerCardClass(index) {
          const classes = ['seller-cyan', 'seller-yellow', 'seller-pink', 'seller-cyan', 'seller-yellow'];
          return `seller-card-base ${classes[index] || 'seller-cyan'}`;
        },
        async fetch(){
            this.loading=true
            //Trayendo el las Sales Notes para saber lo cotizado
            //sort = '', search = '', created_after = '', created_before = '', customer = '', seller = '', has_work_order = '', page = '', page_size = '' 
            var filterSeller=''
            if (!this.$can('realAll', 'SalesNote')){
                const user = this.$store.getters.getUser
                filterSeller=user.id
            }

            //tomando en cuenta fecha UTC porque la busqueda es en timestamp
        var created_before = ''
        var created_after = ''
        var emited_before = ''
        var emited_after = ''
        if(this.dateRange[0]) {
            created_after = moment(this.dateRange[0]).utc().format('yyyy-MM-DD HH:mm')
            emited_after = moment(this.dateRange[0]).format('yyyy-MM-DD')
        }
        if(this.dateRange[1]){
         created_before=moment(this.dateRange[1]).utc().add(1439,'minutes').format('yyyy-MM-DD HH:mm')
         emited_before=moment(this.dateRange[1]).format('yyyy-MM-DD')
        }


            const query=`created_after=${created_after}&created_before=${created_before}&emited_after=${emited_after}&emited_before=${emited_before}&customer__seller=${filterSeller}&monthly=${this.optionSelected.monthly}`

            await fetchDayGraph(query)
            .then((data)=>{
                this.loading=false
                const {quoted,confirmed,confirmed_finished,confirmed_finished_not_invoiced ,invoices, payments, total_quoted,total_confirmed,total_confirmed_finished ,total_confirmed_finished_not_invoiced,total_invoiced, total_payments,total_purchase_subtotal,total_purchase_payments,customers,sellers}=data
                this.quoted=quoted
                this.confirmed=confirmed
                this.confirmed_finished=confirmed_finished
                this.cofirmed_finished_not_invoiced=confirmed_finished_not_invoiced
                this.invoices=invoices
                this.payments=payments
                this.total_quoted=total_quoted
                this.total_confirmed=total_confirmed
                this.total_confirmed_finished=total_confirmed_finished
                this.total_confirmed_finished_not_invoiced=total_confirmed_finished_not_invoiced
                this.total_invoiced=total_invoiced
                this.total_payments=total_payments
                this.total_purchase_subtotal=total_purchase_subtotal
                this.total_purchase_payments=total_purchase_payments
                this.customers=customers
                this.sellers=sellers
            })
            console.log('fetching data sales dashboard',this.sellers)
        }
    },
    async mounted(){
    this.optionSelected = this.dataRange[0]
    this.fetch()
    this.timeInterval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
    this.$root.$on('update-dashboard', this.fetch);
    },
    beforeDestroy() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
      }
      this.$root.$off('update-dashboard', this.fetch);
    },
     watch:{
   //Revisa cambios en options para solicitar data nuevamente
   optionSelected:{
     deep: true,
     handler: 'fetch'
   }
 }
}
</script>

<style scoped>
.dashboard-container {
  min-height: 90vh;
  background: #f5f5f500;
  padding: 0px 20px 0px 20px;
}

.can-wrapper {
  display: contents;
}

.dashboard-title {
  font-size: 1.2rem;
  color: #202124;
  font-weight: 600;
}

.current-time {
  font-size: 1rem;
  font-weight: 600;
  color: #202124;
}

.current-date {
  font-size: 0.8rem;
  color: #5f6368;
  font-weight: 500;
}

/* Estilos de las tarjetas métricas - Google Analytics 4 style */
.metric-card {
  border-radius: 12px;
  border: 2px solid #e8eaed;
  transition: all 0.2s ease;
  cursor: pointer;
  background: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.metric-card:hover {
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15), 0 4px 8px rgba(0, 0, 0, 0.1);
  border-color: #dadce0;
}

.metric-header {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
}

.metric-icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
}

.metric-title {
  color: #5f6368;
  font-size: 1rem;
  font-weight: 500;
  flex: 1;
}

.metric-body {
  display: flex;
  flex-direction: column;
}

.metric-value {
  font-size: 3.5rem;
  font-weight: 700;
  color: #202124;
  line-height: 1;
}

.metric-label {
  font-size: 0.7rem;
  color: #5f6368;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Colores de iconos - Google Analytics 4 style */
.blue-bg {
  background: #4285f4;
}

.orange-bg {
  background: #ff9800;
}

.purple-bg {
  background: #9c27b0;
}

.gray-bg {
  background: #757575;
}

.teal-bg {
  background: #009688;
}

.red-bg {
  background: #f44336;
}





.seller-card-base {
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 6px;
  border: 1px solid;
}

.seller-cyan {
  background: #e0f7fa;
  border-color: #00bcd4;
}

.seller-yellow {
  background: #fffde7;
  border-color: #ffeb3b;
}

.seller-pink {
  background: #fce4ec;
  border-color: #e91e63;
}

.seller-content {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.seller-ranking {
  margin-right: 8px;
}

.ranking-number {
  font-size: 1.2rem;
  font-weight: 700;
  color: #202124;
  width: 28px;
  text-align: center;
}

.seller-info {
  flex: 1;
  display: flex;
  align-items: center;
}





.amount-item {
  text-align: right;
}

.amount-label {
  font-size: 0.7rem;
  color: #5f6368;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 0px;
}

.amount-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #202124;
}





</style>